import { api, ep } from "aldoo-ra/API"
import axios from "axios"

const orgApi = api("organizations")

export async function createOrg(name) {
    return orgApi({ create: { name } })
}

export async function updateOrg(orgId, name) {
    return orgApi({ update: { orgId, name } })
}

export async function getOrg(orgId) {
    return orgApi({ get: { orgId } })
}

export async function listOrgs() {
    return orgApi({ list: {} })
}

export async function sendInvites(orgId, emails) {
    return orgApi({ invite: { orgId, emails } })
}

export async function removeMember(orgId, userId) {
    return orgApi({ remove: { orgId, userId } })
}

export async function promoteMember(orgId, userId) {
    return orgApi({ promote: { orgId, userId } })
}

export async function demoteMember(orgId, userId) {
    return orgApi({ demote: { orgId, userId } })
}

export async function listMembers(orgId) {
    return orgApi({ members: { orgId } })
}

export async function deleteOrg(orgId) {
    return orgApi({ delete: { orgId } })
}

export async function removeInvite(orgId, inviteId) {
    return orgApi({ invite_remove: { orgId, inviteId } })
}

export async function resendInvite(orgId, inviteId) {
    return orgApi({ invite_resend: { orgId, inviteId } })
}

export async function listTeams(orgId) {
    return orgApi({ team_list: { orgId } })
}

export async function createTeam(orgId, name) {
    return orgApi({ team_create: { orgId, name } })
}

export async function deleteTeam(orgId, teamId) {
    return orgApi({ team_delete: { orgId, teamId } })
}

export async function renameTeam(orgId, teamId, name) {
    return orgApi({ team_rename: { orgId, teamId, name } })
}

export async function setTeamMembers(orgId, teamId, members) {
    return orgApi({ team_set_members: { orgId, teamId, members } })
}

export async function acceptInvite(token) {
    return api("organizations/invite/accept")({ accept: { token } })
}

export async function uploadOrgLogo(orgId, blob, mimeType) {
    const { getValue } = await import("aldoo-ra/Value")
    const credentials = getValue("user-credentials", "user-credentials")
    const ext = mimeType?.split("/")?.[1] || "jpg"
    const formData = new FormData()
    formData.append("logo_upload", blob, `logo.${ext}`)
    formData.append("orgId", orgId)
    const headers = {}
    if (credentials?.auth_token) headers["Authorization"] = credentials.auth_token
    const response = await axios.post(ep("organizations"), formData, { headers })
    return response.data
}

export function orgLogoUrl(orgId) {
    return `${ep("organizations")}/logo/${orgId}`
}
